import { http } from "@/communication";

const adminBadgesModule = {
  namespaced: true,
  state: {
    member: {
      support: [],
      report: [],
      review: [],
      transaction: []
    },
    moderator: {
      support: []
    },
    blacklist: {
      message: []
    }
  },
  actions: {
    read({ commit }, sideBarLink) {
      let taskType = sideBarLink.split("/");
      let urls = {
        "member/review": "/api/v1/customerReview/untreatedIDs",
        "member/support": "/api/v1/supportTicket/untreatedIDs",
        "member/report": "/api/v1/userReport/untreatedIDs",
        "moderator/support": "/api/v1/moderatorSupportMessage/untreatedIDs",
        "blacklist/message": "/api/v1/blacklistMessage/untreatedIDs",
        "member/transaction": "/api/v1/transaction/untreatedIDs"
      };
      return http
        .get(urls[sideBarLink])
        .then(({ data }) => {
          commit("update", { ids: data, taskType: taskType });
        })
        .catch(error => {
          console.log(`${name}s error`, error);
        });
    }
  },
  mutations: {
    update(state, data) {
      state[data.taskType[0]][data.taskType[1]] = data.ids;
    },
    newAdminTask(state, data) {
      let taskType = data.adminTask.split("/");
      state[taskType[0]][taskType[1]].indexOf(data.relatedTaskId) === -1
        ? state[taskType[0]][taskType[1]].push(data.relatedTaskId)
        : null;
    },
    treatedAdminTask(state, data) {
      let taskType = data.adminTask.split("/");
      state[taskType[0]][taskType[1]] = state[taskType[0]][taskType[1]].filter(
        curTaskId => {
          return curTaskId != data.relatedTaskId;
        }
      );
    }
  },
  getters: {
    memberReview: state => state.member.review.length,
    memberSupport: state => state.member.support.length,
    memberReport: state => state.member.report.length,
    memberAll: state =>
      state.member.support.length +
      state.member.report.length +
      state.member.review.length,
    moderatorSupport: state => state.moderator.support.length,
    blacklistMessage: state => state.blacklist.message.length,
    moderatorAll: state =>
      state.moderator.support.length + state.blacklist.message.length,
    memberTransaction: state => state.member.transaction.length
  }
};

export default adminBadgesModule;
